/**
 * Initialize Microsoft Clarity (session recordings, heatmaps).
 * Can be driven by:
 * 1. Integration: pass projectId from an active Microsoft Clarity integration (Settings → Integrations).
 * 2. Env fallback: VITE_CLARITY_PROJECT_ID (only in production unless VITE_CLARITY_ENABLED=true).
 * @see https://docs.microsoft.com/en-us/clarity/
 * @param {string} [projectId] - Clarity project ID (from integration settings or env)
 */
export function initClarity(projectId) {
  const id =
    projectId ||
    (import.meta.env.PROD || import.meta.env.VITE_CLARITY_ENABLED === 'true'
      ? import.meta.env.VITE_CLARITY_PROJECT_ID
      : null);

  if (!id) {
    if (import.meta.env.DEV) {
      console.log('[Clarity] Disabled (no project ID from integration or env)');
    }
    return;
  }

  // Avoid loading the same project twice
  if (window.__clarityProjectId === id) return;
  if (document.querySelector('script[src*="clarity.ms/tag/' + id + '"]')) return;

  window.__clarityProjectId = id;

  try {
    (function (c, l, a, r, i, t, y) {
      c[a] =
        c[a] ||
        function () {
          (c[a].q = c[a].q || []).push(arguments);
        };
      t = l.createElement(r);
      t.async = 1;
      t.src = 'https://www.clarity.ms/tag/' + i;
      y = l.getElementsByTagName(r)[0];
      y.parentNode.insertBefore(t, y);
    })(window, document, 'clarity', 'script', id);
  } catch (err) {
    console.warn('[Clarity] Failed to load:', err);
  }
}
